import { useState, useCallback } from 'react';
import api from '../api';

export function useStripe() {
  const [isProcessing, setIsProcessing] = useState(false);
  const [checkoutUrl, setCheckoutUrl] = useState(null);

  const createCheckout = useCallback(async ({ exportId, quantity, priceCents, email, successUrl, cancelUrl }) => {
    setIsProcessing(true);
    setCheckoutUrl(null);
    try {
      const response = await api.post('/payments/checkout', {
        export_id: exportId,
        quantity,
        price_cents: priceCents,
        customer_email: email,
        success_url: successUrl,
        cancel_url: cancelUrl
      });
      
      if (response.data.checkout_url) {
        setCheckoutUrl(response.data.checkout_url);
        // Redirect directly to Stripe Checkout
        window.location.href = response.data.checkout_url;
      }
      return response.data;
    } catch (err) {
      console.error('[Stripe] Checkout creation failed:', err);
      throw err;
    } finally {
      setIsProcessing(false);
    }
  }, []);

  return {
    createCheckout,
    isProcessing,
    checkoutUrl
  };
}
